/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_ImsInputs */

const en_mapping_system_ims = /** @type {(inputs: Mapping_System_ImsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IMS`)
};

/**
* | output |
* | --- |
* | "IMS" |
*
* @param {Mapping_System_ImsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_ims = /** @type {((inputs?: Mapping_System_ImsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_ImsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_ims(inputs)
});